<template lang="pug">

  .dailyReportHour(:class="{ 'dailyReportHour--opened': open === true }")

    .dailyReportTimeWrapper(@click="setTimeAccordionStatus" :class="{ 'dailyReportTimeWrapper--clickable': timeDoctors.length > 0 }")

      .dailyReportTime {{ shiftTime }}
      .dailyReportCount(v-if="loading === true") Carregando...
      .dailyReportCount(v-else-if="timeDoctors.length > 0") {{ timeDoctors.length }} plantonista(s)
      .dailyReportCount(v-else-if="timeDoctors.length === 0") Nenhum plantonista

      .dailyReportDoctorsHorizontal(v-if="loading === false")
        template(v-if="timeDoctors.length > 0")
          .doctorAvatar(v-for="(doctorItem, doctorIndex) in timeDoctors" :key="'doctor_' + doctorIndex + '_' + doctorItem.doctorID" :style="{ backgroundImage: 'url(' + doctorItem.doctorImage + ')' }" :title="doctorItem.doctorShift")
        template(v-else)
          span &nbsp;
      .dailyReportDoctorsHorizontal(v-else)
        span &nbsp;

    .dailyReportDoctors(v-if="timeDoctors.length > 0 && open === true")

      .dailyReportDoctor--header
        .doctorColumn1 Plantonista
        .doctorColumn2 Início
        .doctorColumn3 Fim
        .doctorColumn4 Duração
      .dailyReportDoctor(v-for="(doctorItem, doctorIndex) in timeDoctors" :key="'doctor_' + doctorIndex + '_' + doctorItem.doctorID")
        .doctorColumn1
          //- .doctorAvatar(:style="{ backgroundImage: 'url(' + doctorItem.doctorImage + ')' }" :title="doctorItem.doctorShift")
          .doctorAvatar(:style="{ backgroundImage: 'url(' + doctorItem.doctorImage + ')' }")
          .doctorName
            | {{ doctorItem.doctorShortName }}
        .doctorColumn2
          | {{ doctorItem.doctorStart }}
        .doctorColumn3
          | {{ doctorItem.doctorEnd }}
        .doctorColumn4
          | {{ doctorItem.shiftDuration }}

</template>

<script>

  export default {
    name: 'DailyReportTimeItem',

    props: {
      shiftTime: {
        type: String,
        default: () => '',
      },
      timeDoctors: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: () => false,
      },
    },

    data () {
      return {
        open: false,
      }
    },

    watch: {
      loading: {
        immediate: true,
        handler (currentLoading, oldLoading) {
          if (currentLoading !== oldLoading) this.open = false
        },
      },
    },

    /* mounted () {
      // [24/01/25] console.log('::: dailyReportTimeItem:', this.time)
    }, */

    methods: {
      setTimeAccordionStatus () {
        if (this.timeDoctors.length > 0) this.open = !this.open
      },
    },
  }

</script>

<!-- <style lang="sass" scoped> </style> -->
